/* KS gift engine — makes the cart match the server-rendered gift state.
 *
 * Price truth  = native Shopify BXGY (100% off 1 gift unit, usesPerOrderLimit 1).
 * Eligibility  = Liquid in snippets/ks-gift-block.liquid, re-rendered via the
 *                Section Rendering API by ks-cart-progress.js on every cart change,
 *                which swaps [data-ks-gift-block] and fires `ks:gift:rendered`.
 * This file     = reconcile only: add the gift line when qualified & missing,
 *                 pin qty to 1, remove it when no longer qualified / not free.
 *
 * Safety: only lines carrying properties._ks_gift=<promo handle> are touched;
 * one action per promo per render; 2 s lock; max 3 actions / 60 s per promo.
 * Design: md/gift-engine-design-20261005.md
 */
(function () {
  if (window.__ksGiftEngine) return;
  window.__ksGiftEngine = true;

  var lock = {}, hits = {}, soldOut = {};
  var DEBUG = /ks_debug=1/.test(location.search) || localStorage.getItem('ks_gift_debug') === '1';
  function log() { if (DEBUG) console.log.apply(console, ['[KS Gift]'].concat([].slice.call(arguments))); }

  function states() {
    var out = [];
    document.querySelectorAll('[data-ks-gift-state]').forEach(function (s) {
      try { out.push(JSON.parse(s.textContent)); } catch (e) { console.warn('[KS Gift] bad state json', e); }
    });
    return out;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshTheme() {
    // Broadcast's cart-drawer / cart page listen to this and rebuild their line
    // items, then fire theme:cart:change → ks-cart-progress re-renders the slot
    // → ks:gift:rendered → reconcile() again (should be a no-op by then).
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function act(promo, path, body, why) {
    var now = Date.now();
    if (lock[promo] && now < lock[promo]) { log('locked', promo, why); return Promise.resolve(false); }
    hits[promo] = (hits[promo] || []).filter(function (t) { return now - t < 60000; });
    if (hits[promo].length >= 3) { console.warn('[KS Gift] loop guard tripped for', promo, why); return Promise.resolve(false); }
    lock[promo] = now + 2000; hits[promo].push(now);
    log('→', why, path, body);
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          console.warn('[KS Gift] cart call failed', r.status, j);
          if (path === 'cart/add.js' && (r.status === 422 || r.status === 404)) soldOut[promo] = true;
          document.dispatchEvent(new CustomEvent('ks:gift:error', { detail: { promo: promo, status: r.status, body: j } }));
          return false;
        });
      }
      document.dispatchEvent(new CustomEvent('ks:gift:action', { detail: { promo: promo, path: path, why: why } }));
      refreshTheme();
      return true;
    }).catch(function (e) { console.warn('[KS Gift] network', e); return false; });
  }

  function reconcile() {
    var list = states();
    if (!list.length) return;
    list.forEach(function (s) {
      log('state', s.handle, s.state, 'qualified=' + s.qualified, 'line=' + s.giftLineKey, 'free=' + s.giftFree);
      if (s.qualified && !s.giftLineKey) {
        if (!s.giftAvailable || soldOut[s.handle]) { log('qualified but gift unavailable', s.handle); return; }
        act(s.handle, 'cart/add.js', { items: [{ id: s.variantId, quantity: 1, properties: { _ks_gift: s.handle } }] }, 'add gift');
      } else if (s.giftLineKey && s.giftQty !== 1) {
        act(s.handle, 'cart/change.js', { id: s.giftLineKey, quantity: 1 }, 'pin qty');
      } else if (s.giftLineKey && (!s.qualified || (!s.giftFree && !s.anyUnitFree))) {
        act(s.handle, 'cart/change.js', { id: s.giftLineKey, quantity: 0 }, s.qualified ? 'remove (not free)' : 'remove (below threshold)');
      }
    });
  }

  // Standalone mode (/cart page): no drawer slot, so ks-cart-progress.js never
  // re-renders. Re-fetch the section that holds [data-ks-gift-standalone] ourselves.
  var saTimer = null;
  function standaloneHost() {
    if (document.querySelector('#ks-free-shipping-progress-slot [data-ks-gift-block]')) return null;
    return document.querySelector('[data-ks-gift-standalone]');
  }
  function refreshStandalone() {
    var host = standaloneHost();
    if (!host) return;
    var sec = host.closest('[id^="shopify-section-"]');
    if (!sec) return;
    var id = sec.id.replace('shopify-section-', '');
    fetch(location.pathname + '?sections=' + id, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[id]) return;
        var doc = new DOMParser().parseFromString(j[id], 'text/html');
        var next = doc.querySelector('[data-ks-gift-standalone]');
        var live = standaloneHost();
        if (next && live) live.replaceWith(document.importNode(next, true));
        document.dispatchEvent(new CustomEvent('ks:gift:rendered', { detail: { standalone: true } }));
      }).catch(function (e) { console.warn('[KS Gift] standalone refresh failed', e); });
  }
  function scheduleStandalone() {
    if (!standaloneHost()) return;
    clearTimeout(saTimer); saTimer = setTimeout(refreshStandalone, 800);
  }
  ['theme:cart:change', 'theme:cart:update', 'theme:product:add', 'cart:updated', 'cart:refresh'].forEach(function (e) {
    document.addEventListener(e, scheduleStandalone);
  });

  // Strip ticks: Liquid only knows the bar maximum after its loop, so positions are set here.
  function positionTicks() {
    document.querySelectorAll('[data-ks-strip]').forEach(function (s) {
      var max = Number(s.getAttribute('data-ks-bar-max') || 0); if (!max) return;
      s.querySelectorAll('[data-ks-tick-cents]').forEach(function (t) {
        t.style.left = Math.min(100, Number(t.getAttribute('data-ks-tick-cents')) * 100 / max) + '%';
      });
    });
  }
  // ---- VVIP 88 折 (native code discount VVIP12Off, FB_VVIP segment) ----
  // Liquid emits [data-ks-vip-state] only for logged-in FB_VVIP customers. We apply the
  // code through the Cart API when the eligible 直郵 subtotal reaches the threshold, and
  // remove it again below it, so checkout never shows an "invalid code" banner.
  var vipBusy = false, vipHits = [], vipSkipCents = null;
  function vipState() {
    var s = document.querySelector('[data-ks-vip-state]'); if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function cartPost(path, body) {
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }); });
  }
  function codesOf(cart) { return (cart && cart.discount_codes) || []; }
  function reconcileVip() {
    var v = vipState(); if (!v || vipBusy) return;
    var now = Date.now(); vipHits = vipHits.filter(function (t) { return now - t < 60000; });
    var want = v.eligibleCents >= v.thresholdCents;
    var up = v.code.toUpperCase();
    if (want && !v.applied) {
      if (vipSkipCents === v.eligibleCents) { log('vip: Shopify said not applicable at', v.eligibleCents); return; }
      if (vipHits.length >= 3) { console.warn('[KS Gift] vip loop guard'); return; }
      vipBusy = true; vipHits.push(now); log('vip: apply', v.code, v.eligibleCents);
      cartPost('cart/update.js', { discount: v.code }).then(function (cart) {
        var mine = codesOf(cart).filter(function (c) { return (c.code || '').toUpperCase() === up; })[0];
        if (mine && mine.applicable) { log('vip: applied'); refreshTheme(); return; }
        vipSkipCents = v.eligibleCents;
        var keep = codesOf(cart).filter(function (c) { return (c.code || '').toUpperCase() !== up; }).map(function (c) { return c.code; }).join(',');
        log('vip: not applicable, reverting to', keep);
        return cartPost('cart/update.js', { discount: keep });
      }).catch(function (e) { console.warn('[KS Gift] vip', e); }).then(function () { vipBusy = false; });
    } else if (!want && v.applied) {
      if (vipHits.length >= 3) { console.warn('[KS Gift] vip loop guard'); return; }
      vipBusy = true; vipHits.push(now); log('vip: remove', v.code, v.eligibleCents);
      fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var keep = codesOf(cart).filter(function (c) { return (c.code || '').toUpperCase() !== up; }).map(function (c) { return c.code; }).join(',');
        return cartPost('cart/update.js', { discount: keep });
      }).then(function () { refreshTheme(); }).catch(function (e) { console.warn('[KS Gift] vip', e); }).then(function () { vipBusy = false; });
    } else if (want && v.applied) {
      vipSkipCents = null;
    }
  }

  document.addEventListener('ks:gift:rendered', function () { positionTicks(); reconcile(); reconcileVip(); });

  function boot() { positionTicks(); reconcile(); reconcileVip(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.ksGift = { reconcile: reconcile, states: states, vip: reconcileVip, vipState: vipState };
})();
